export const apiUrl = function() {
    if (location.hostname === 'portal.my247ed.com') {
        return '/';
    } else if (location.hostname === 'localhost') {
        return 'http://localhost:3000/';
    }
    // Fail safe: unrecognized hosts (.lan addresses, LAN IPs) use the dev API, never production.
    return 'https://api.my247ed.lan/';
}();
